import styles from './InfoSection.module.css';
import { Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { useConfigContext } from '../../context/ConfigContext';

export default function InfoSection({ pageTitle }: { pageTitle: string }) {
  return (
    <div className={styles.infoContainer}>
      <div className={styles.infoContainerFlex}>
	<div style={{ flex: 1 }}>
	  <InfoText pageTitle={pageTitle} />
	</div>
	<div style={{ display: 'flex', flexDirection: 'column-reverse' }}>
	  <p
	    style={{
	      fontSize: '17',
	      border: '#c0c0c0 solid 2px',
	      padding: '1em',
	      borderRadius: 10
	    }}
	  >
	    <span style={{ color: '#ffcc00' }}>Unsere telefonischen Bürozeiten:</span>
	    <br />
	    Mo. + Di. + Do.: 12:00 – 18:00
	    <br />
	    Mi. : 12:00 – 15:00
	    <br />
	    Fr. - So. ist keine Bürozeit!
	  </p>
	</div>
      </div>
    </div>
  );
}

function InfoText({ pageTitle }: { pageTitle: string }) {
  const config = useConfigContext();

  if (pageTitle === 'Club-Finder') {
    return (
      <div>
	<p>Ausschließlich für Mitglieder im Premium Club-System</p>
	<p>
	  Als Premium-Mitglied darfst Du mehrfach die Woche mit Deinem Partner/in zum Unterricht
	  kommen.
	  <br />
	  Wie finde ich aber die für mich passenden Club-Termine?
	</p>
	<ul>
	  <li>
	    <p>Finde in der untenstehende Liste Deinen angestammten Clubtermin.</p>
	  </li>
	  <li>
	    <p>
	      Du kannst alle anderen Clubtermine besuchen, die entweder die gleiche Farbcodierung
	      haben, oder aber im Ton heller sind als Dein Termin.
	    </p>
	  </li>
	</ul>
	<p className={styles.color}>Änderungen vorbehalten!</p>
      </div>
    );
  }
  if (pageTitle === 'Refreshtanzen') {
    return (
      <div>
	<p>
	  Das 60 minütige Refreshtanzen ist für alle Paare geeignet, die sich bei Schritten/Figuren
	  ihres Kursprogrammes unsicher fühlen und mit einer gezielten Unterstützung kleine Probleme
	  in den Griff bekommen wollen.
	  <br /> Für größere Lücken, die entstehen, wenn man längere Zeit in seinem Kurs gefehlt hat
	  und einzelne Figuren im Unterricht nicht mitbekommen hat, empfehlen wir das Vereinbaren
	  von Privatstunden.
	</p>
	<p>
	  Preis für Mitglieder im Premium Club-System: {config.REFRESH_PRICE_MEMBER_PREMIUM} <br />
	  Preis für alle anderen Mitglieder der Tanzschule: {config.REFRESH_PRICE_MEMBER}
	  <br />
	  Teilnahme nur für aktiv tanzende Mitglieder!
	</p>
	<p>
	  Die einzelnen Refresh-Termine finden nur bei genügend Reservierungen statt. <br />
	  <b>
	    <br />
	    Bei einem <span style={{ color: '#fc0' }}>gelben</span> Ampelsymbol ist der gewünschte
	    Kurs reservierbar, aber die Mindestteilnehmerzahl, damit der Kurs stattfinden kann, noch
	    nicht erreicht.
	    <br />
	    Ein stattfindender Kurs ist durch das <span style={{ color: 'green' }}>grüne</span>{' '}
	    Symbol gekennzeichnet. Auch für stattfindende{' '}
	    <span style={{ color: 'green' }}>(grüne)</span> Kurse ist eine Reservierung zwingend
	    notwendig.
	    <br />
	    <span style={{ color: 'red' }}>Rot</span> gekennzeichnete Kurse werden nicht
	    stattfinden.
	  </b>
	</p>
	<br />
	<p>
	  {' '}
	  Anmeldeschluss ist jeweils {config.DAYS_REGISTRATION_DEADLINE_REFRESH} Tage vor Beginn.
	  {'\n'}
	  In diesen {config.DAYS_REGISTRATION_DEADLINE_REFRESH} Tagen vor Beginn ist auch eine
	  kostenfreie Stornierung der Teilnahme bei bereits erfolgter Reservierung nicht mehr
	  möglich.
	</p>
	<p>Eine Reservierung ist nur paarweise möglich.</p>
	<p className={styles.color}>Änderungen vorbehalten!</p>
      </div>
    );
  }
  if (pageTitle === 'Workshops') {
    return (
      <div>
	<h3>Workshop</h3>
	<p>
	  Unsere Workshops beschäftigen sich intensiv mit einzelnen Tänzen und Themen aus der
	  vielfältigen Welt des Tanzens. <br />
	  Auf dem Programm stehen z.B. Tango Argentino, Salsa, spezifische Tanztechniken und
	  Weiteres.{' '}
	</p>
	<p>
	  Alle Workshops werden von Trainerinnen und Trainern mit hervorragenden Kenntnissen im
	  entsprechendem Spezialgebiet durchgeführt.
	  <br />
	  Die Workshops finden in verschiedenen Leveln statt. Wer unsicher ist, ob ein Workshop für
	  ihn passend ist, kann sich jederzeit zu unseren Bürozeiten mit uns in Verbindung setzen
	  oder seine/n Tanzlehrer/in im Unterricht ansprechen.
	</p>
	<p>
	  Preise und sonstige Informationen werden für die einzelnen Workshops gesondert
	  ausgewiesen. Auch für Mitglieder im Premium-Clubsystem sind diese Workshops
	  kostenpflichtig.
	</p>
	<br />
	<p>
	  Die einzelnen Workshops finden nur bei genügend Reservierungen statt. <br />
	  <b>
	    <br />
	    Bei einem <span style={{ color: '#fc0' }}>gelben</span> Ampelsymbol ist der gewünschte
	    Workshop reservierbar, aber die Mindestteilnehmerzahl, damit der Kurs stattfinden kann,
	    noch nicht erreicht.
	    <br />
	    Ein stattfindender Workshop ist durch das <span style={{ color: 'green' }}>grüne</span>{' '}
	    Symbol gekennzeichnet. Auch für stattfindende{' '}
	    <span style={{ color: 'green' }}>(grüne)</span> Workshops ist eine Reservierung zwingend
	    notwendig.
	    <br />
	    <span style={{ color: 'red' }}>Rot</span> gekennzeichnete Workshops werden nicht
	    stattfinden.
	  </b>
	  <br />
	  <br />
	  <p>
	    Anmeldeschluss ist jeweils {config.DAYS_REGISTRATION_DEADLINE_WORKSHOP} Tage vor
	    Workshopbeginn.{'\n'}
	    In diesen {config.DAYS_REGISTRATION_DEADLINE_WORKSHOP} Tagen vor Workshopbeginn ist auch
	    eine kostenfreie Stornierung der Teilnahme bei bereits erfolgter Reservierung nicht mehr
	    möglich.
	  </p>
	</p>
	<p>Eine Reservierung ist nur paarweise möglich.</p>
	<p className={styles.color}>Änderungen vorbehalten!</p>
      </div>
    );
  }
  if (pageTitle === 'TCE-Sonderkurse') {
    return (
      <div>
	<h3>TCE-Sonderkurse</h3>
	<p>
	  Unsere TCE-Sonderkurse beschäftigen sich intensiv mit einzelnen Tänzen aus der
	  vielfältigen Welt der Tänze. <br />
	  Auf dem Programm stehen z.B. Salsa, Tango Argentino, Technik-Kurse und weitere.{' '}
	</p>
	<p>Die Unterrichtszeit beträgt 60 Minuten (90 Minuten, siehe einzelnes Kursangebot). </p>
	<p className={styles.onlyDesktop}>
	  <div className={styles.flex}>
	    Unsere Workshops finden in verschiedenen Leveln statt
	    <Tooltip
	      componentsProps={{
		tooltip: {
		  sx: {
		    bgcolor: '#333333'
		  }
		}
	      }}
	      title={
		<div className={styles.fontSize}>
		  <p>Der Schwierigkeitsgrad wird in Level eingeteilt:</p>
		  <p>
		    <div className={styles.level}>Beginner</div>
		    noch keine Tanzerfahrung mit diesem Tanz
		  </p>
		  <p>
		    <div className={styles.level}>Level 1</div>
		    Grundkenntnisse sind vorhanden und können sicher getanzt werden
		  </p>
		  <p>
		    <div className={styles.level}>Level 2</div>
		    Erlernen von fortgeschrittenen Elementen
		  </p>
		  <p>
		    <div className={styles.level}>Level 3 und 4</div>
		    Kurse für Paare mit sehr guten und mehrjährigen Tanzerfahrungen in den
		    jeweiligen Tänzen.
		  </p>
		</div>
	      }
	      placement={'right'}
	      arrow
	      enterTouchDelay={0}
	    >
	      <InfoOutlined className={styles.color} />
	    </Tooltip>
	  </div>
	</p>
	<p className={styles.onlyMobile}>
	  <p>Der Schwierigkeitsgrad wird in Level eingeteilt:</p>
	  <p>
	    <div className={styles.level}>Beginner</div>
	    noch keine Tanzerfahrung mit diesem Tanz
	  </p>
	  <p>
	    <div className={styles.level}>Level 1</div>
	    Grundkenntnisse sind vorhanden und können sicher getanzt werden
	  </p>
	  <p>
	    <div className={styles.level}>Level 2</div>
	    Erlernen von fortgeschrittenen Elementen
	  </p>
	  <p>
	    <div className={styles.level}>Level 3 und 4</div>
	    Kurse für Paare mit sehr guten und mehrjährigen Tanzerfahrungen in den jeweiligen
	    Tänzen.
	  </p>
	</p>
	<p>
	  Preis für alle Mitglieder im Premium-Club: kostenfrei
	  <br />
	  Preis für einen einzelnen Kurstermin/Schnuppertermin 60 Min.: €22 / Person <br />
	  Preis für 5er-Karte (5 Termine / 60 Min. Deiner Wahl): €100 / Person <br />
	  Preis für 10er-Karte (10 Termine / 60 Min. Deiner Wahl): €180 / Person <br />
	</p>
	<p>
	  Die 5er-Karte/10er-Karte kann nach vorheriger Reservierung bei der ersten Teilnahme an
	  einem Sonderkurs direkt in der Tanzschule erworben werden.
	</p>

	<p>
	  Die einzelnen TCE-Sonderkurse finden nur bei genügend Reservierungen statt. <br />
	  <b>
	    <br />
	    Bei einem <span style={{ color: '#fc0' }}>gelben</span> Ampelsymbol ist der gewünschte
	    Kurs reservierbar, aber die Mindestteilnehmerzahl, damit der Kurs stattfinden kann, noch
	    nicht erreicht.
	    <br />
	    Ein stattfindender Kurs ist durch das <span style={{ color: 'green' }}>grüne</span>{' '}
	    Symbol gekennzeichnet. Auch für stattfindende{' '}
	    <span style={{ color: 'green' }}>(grüne)</span> Kurse ist eine Reservierung zwingend
	    notwendig.
	    <br />
	    <span style={{ color: 'red' }}>Rot</span> gekennzeichnete Kurse werden nicht
	    stattfinden.
	  </b>
	</p>
	<br />
	<p>
	  {' '}
	  Anmeldeschluss ist jeweils {config.DAYS_REGISTRATION_DEADLINE_TCECOURSES} Tage vor
	  Kursbeginn.{'\n'}
	  In diesen {config.DAYS_REGISTRATION_DEADLINE_TCECOURSES} Tagen vor Kursbeginn ist auch
	  eine kostenfreie Stornierung der Teilnahme bei bereits erfolgter Reservierung nicht mehr
	  möglich.
	</p>
	<p>Eine Reservierung ist nur paarweise möglich.</p>
	<p className={styles.color}>Änderungen vorbehalten!</p>
	<p className={styles.kleinGedrucktes}>
	  *die Preise verstehen sich bei Lastschrifteinzug. <br />
	  Bei Barzahlung/Überweisung erhöht sich durch den größeren Verwaltungsaufwand der Preis um{' '}
	  {config.TCECOURSES_EXTRA_BAR}.
	</p>
      </div>
    );
  }
  if (pageTitle === 'TCE-Events') {
    return (
      <div>
	<h3>TCE-Events</h3>
	<p>
	  Unsere Veranstaltungen sind ein beliebter Treffpunkt, wo man mit anderen netten Leuten
	  sowohl das Tanzbein schwingen, als auch bei Essen & Trinken gute Gespräche und ein
	  geselliges Miteinander erleben kann.
	  <br />
	  Ein rechtzeitiges Reservieren sichert Plätze!
	</p>
	<p> Die Infos & Preise werden für die einzelnen Veranstaltungen gesondert ausgewiesen.</p>
	<p> Auch für Mitglieder im Premium-Clubsystem sind diese Events kostenpflichtig.</p>
	<p>
	  <b>
	    <br />
	    Bei einem <span style={{ color: '#fc0' }}>gelben</span> Ampelsymbol ist das gewünschte
	    Event reservierbar, aber die Mindestteilnehmerzahl, damit die Party stattfinden kann,
	    noch nicht erreicht.
	    <br />
	    Eine stattfindende Party ist durch das <span style={{ color: 'green' }}>grüne</span>{' '}
	    Symbol gekennzeichnet.
	    <br />
	    <span style={{ color: 'red' }}>Rot</span> gekennzeichnete Partys werden nicht
	    stattfinden.
	  </b>
	  <br />
	  Anmeldeschluss ist jeweils {config.DAYS_REGISTRATION_DEADLINE_EVENT} Tage vor Beginn.
	  {'\n'}
	  In diesen {config.DAYS_REGISTRATION_DEADLINE_EVENT} Tagen vor Beginn ist auch eine
	  kostenfreie Stornierung der Teilnahme bei bereits erfolgter Reservierung nicht mehr
	  möglich.
	</p>
	<p>Eine Reservierung ist nur paarweise möglich.</p>
	<p className={styles.color}>Änderungen vorbehalten!</p>
      </div>
    );
  }
  if (pageTitle === 'Jugend') {
    return (
      <div>
	<h3>Jugendparty</h3>
	<p>
	  Preis für alle Mitglieder der Tanzschule:{' '}
	  <span className={styles.color}>{config.JUGENDPARTY_PRICE_MEMBER}</span>
	  <br />
	  Preis für Nicht-Mitglieder:{' '}
	  <span className={styles.color}>{config.JUGENDPARTY_PRICE_NOT_MEMBER}</span>
	  <b>
	    <br />
	    Bei einem <span style={{ color: '#fc0' }}>gelben</span> Ampelsymbol ist die gewünschte
	    Jugendparty reservierbar, aber die Mindestteilnehmerzahl, damit die Party stattfinden
	    kann, noch nicht erreicht.
	    <br />
	    Eine stattfindende Party ist durch das <span style={{ color: 'green' }}>grüne</span>{' '}
	    Symbol gekennzeichnet.
	    <br />
	    <span style={{ color: 'red' }}>Rot</span> gekennzeichnete Partys werden nicht
	    stattfinden.
	  </b>
	  <br />
	  <br />
	  <span className={styles.color}>Änderungen vorbehalten!</span>
	</p>
      </div>
    );
  }
  if (pageTitle === 'Tanzabend') {
    return (
      <div>
	<h3>Tanzabend</h3>
	<p>
	  Der Tanzabend gibt allen Paaren die Möglichkeit, das Gelernte in netter und entspannter
	  Gesellschaft anderer Paare, in schönem Ambiente und zu abwechslungsreicher Musik
	  auszuprobieren und zu festigen.
	  <br />
	  <br />
	  Preis für Mitglieder der Tanzschule:{' '}
	  <span className={styles.color}>{config.TANZABENDE_PRICE_MEMBER}</span>
	  <br />
	  Preis für Nicht-Mitglieder:{' '}
	  <span className={styles.color}>{config.TANZABENDE_PRICE_NOT_MEMBER}</span>
	  <br />
	  {config.TANZABENDE_FREEDRINK_PRICE && (
	    <p>
	      inklusive ist ein Freigetränk im Gegenwert von max.{' '}
	      <span className={styles.color}>{config.TANZABENDE_FREEDRINK_PRICE}</span> (keine
	      Barauszahlung).
	    </p>
	  )}
	  Eine Reservierung ist für den Tanzabend <b>nicht</b> erforderlich.
	  <br />
	  <br />
	  <b>Frühbucherrabatt:</b>
	  <p>
	    Ausschließlich Mitglieder unserer Tanzschule können bei einer Reservierung zum Tanzabend
	    bis <b>{config.TANZABENDE_DEADLINE}</b> vor dem jeweiligen Termin, den Tanzabend zum
	    günstigeren Preis reservieren: <br /> Preis:{' '}
	    <span className={styles.color}>{config.TANZABENDE_EARLYBIRD_PRICE}</span>
	    {config.TANZABENDE_FREEDRINK_PRICE && (
	      <p>
		inklusive ist ein Freigetränk im Gegenwert von max.{' '}
		<span className={styles.color}>{config.TANZABENDE_FREEDRINK_PRICE}</span> (keine
		Barauszahlung).
	      </p>
	    )}
	    <br />
	    Kann trotz Reservierung die Teilnahme am Tanzabend nicht erfolgen, werden{' '}
	    <b>{config.TANZABENDE_DONT_SHOW_FEE}</b> berechnet.
	  </p>
	  <br />
	  <span className={styles.color}>Änderungen vorbehalten!</span>
	</p>
      </div>
    );
  }
  if (pageTitle === 'TCE-Academy') {
    return (
      <div>
	<h3>TCE-Academy</h3>
	<p>
	  Du hast durch den Paaretanzkurs entdeckt, dass Tanzen für Dich zum Hobby geworden ist und
	  willst nun immer mehr das Gefühl, mit dem Partner über das Parkett zu schweben? Dann
	  brauchst Du mehr Technik, mehr gezielte Übungen, mehr Tanzhaltung…Du brauchst die
	  TCE-Academy. Erreiche Dein nächstes Tanzlevel, egal ob Du das ganz alleine für Dich und
	  Deinen Partner/in machen oder Dich zum Spaß auf einem Turnier des DAT für Tanzschulen
	  ausprobieren möchtest.
	  <br />
	  <br />
	  In der TCE-Academy entwickelst Du Dich tänzerisch weiter mit dem klaren Ziel: richtig gut
	  tanzen zu können.
	  <br />
	  <br />
	  Die Tanzangebote auf dieser Seite sind für Mitglieder der TCE-Academy im Wochenpreis
	  enthalten oder werden durch eine Fremdtrainer-Umlage ergänzt. Die Preise für eine
	  Mitgliedschaft in der TCE-Academy findest Du{' '}
	  <a
	    href={'https://www.tanzcentrum-ettlingen.de/tce-academy'}
	    target="_blank"
	    rel="noreferrer"
	  >
	    hier
	  </a>
	  <br />
	  <br />
	  Für Paare, die das Angebot der Academy ab und zu nutzen möchten, ohne Academy-Mitglied zu
	  sein, sind die Trainings auch einzeln reservierbar: <br />
	  Preis für einen einzelnen Kurstermin/Schnuppertermin 90 Min.: €33 / Person <br />
	  Preis für 5er-Karte (5 Termine / 90 Min. Deiner Wahl): €150 / Person <br />
	  Preis für 10er-Karte (10 Termine / 90 Min. Deiner Wahl): €270 / Person
	  <br />
	  <br />
	  Nur für die Trainingseinheiten mit einem Fremdtrainer ist eine Reservierung erforderlich!
	  Es gilt: Bei einem <span style={{ color: '#fc0' }}>gelben</span> Ampelsymbol ist der
	  gewünschte Kurs reservierbar, aber die Mindestteilnehmerzahl, damit der Kurs stattfinden
	  kann, noch nicht erreicht. Bei einem <span style={{ color: 'green' }}>grünen</span>{' '}
	  Ampelsymbol findet der Kurs statt. Auch für stattfindende (grüne) Kurse ist eine
	  Reservierung zwingend notwendig. <span style={{ color: 'red' }}>Rot</span> gekennzeichnete
	  Kurse werden nicht stattfinden.
	  <br />
	  <br />
	  Reservierungsschluss für Kurse mit Fremdtrainer ist jeweils{' '}
	  {config.DAYS_REGISTRATION_DEADLINE_TCE_ACADEMY} Tage vor Kursbeginn. In diesen{' '}
	  {config.DAYS_REGISTRATION_DEADLINE_TCE_ACADEMY} Tagen vor Kursbeginn ist die kostenfreie
	  Stornierung der Teilnahme bei bereits erfolgter Reservierung nicht mehr möglich. Eine
	  Reservierung ist nur paarweise möglich.
	</p>
	<br />
	<span className={styles.color}>Änderungen vorbehalten!</span>
	<p className={styles.kleinGedrucktes}>
	  *die Preise verstehen sich bei Lastschrifteinzug. <br />
	  Bei Barzahlung/Überweisung erhöht sich durch den größeren Verwaltungsaufwand der Preis um{' '}
	  {config.TCE_ACADEMY_EXTRA_BAR}.
	</p>
      </div>
    );
  }
  return <div />;
}
